export default "__VITE_ASSET__07d5aded__"